import React from 'react';
import Undraw from 'react-undraw';
import styled from 'styled-components';

const PageContainer = styled.div`
  margin: 64px;
  display: flex;
  align-items: center;
`;
const PageNotFound = () => {
  return (
    <PageContainer>
      <Undraw primaryColor='#076e47' name='page-not-found' />;
    </PageContainer>
  );
};

export default PageNotFound;
